// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface Options
 */
export interface Options {
  /**
   *
   */
  every: string;
  /**
   *
   */
  onlyOnce: boolean;
  /**
   *
   */
  active: boolean;
}

/**
 * Check if a given object implements the Options interface.
 */
export function instanceOfOptions(value: object): value is Options {
  if (!("every" in value) || value["every"] === undefined) return false;
  if (
    (!("onlyOnce" in (value as Record<string, any>)) &&
      !("only_once" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["onlyOnce"] === undefined &&
      (value as Record<string, any>)["only_once"] === undefined)
  )
    return false;
  if (!("active" in value) || value["active"] === undefined) return false;
  return true;
}

export function OptionsFromJSON(json: any): Options {
  return OptionsFromJSONTyped(json, false);
}

export function OptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Options {
  if (json == null) {
    return json;
  }
  return {
    every: json["every"],
    onlyOnce: json["only_once"],
    active: json["active"],
  };
}

export function OptionsToJSON(json: any): Options {
  return OptionsToJSONTyped(json, false);
}

export function OptionsToJSONTyped(
  value?: Options | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    every: value["every"],
    only_once: value["onlyOnce"],
    active: value["active"],
  };
}
